import { FallbackProps } from 'react-error-boundary'
import { useTranslation } from 'react-i18next'
import { Button } from 'reactstrap'

const QueryErrorFallback = ({ resetErrorBoundary }: FallbackProps) => {
    const { t } = useTranslation()

    return (
        <div className="d-flex flex-column align-items-center justify-content-center text-center bg-white py-5">
            <i className="mdi mdi-alert-circle-outline display-5 text-danger d-block mb-3" />
            <p className="text-muted mb-3">{t('app.common.errorMessage')}</p>
            <Button color="primary" onClick={resetErrorBoundary}>
                {t('button.tryAgain')}
            </Button>
        </div>
    )
}

export default QueryErrorFallback
